import {defineStore} from 'pinia'
import xhr from "@/utils/xhr";
import {NotificationStores} from "@/stores/NotificationStores";
import {jsonValidator} from "@/utils/JsonValidator";
import {t} from "@/utils/Traduction";

export const TypeAchatStore = defineStore("TypeAchatStore", {
    state: () => ({
        typeAchat: [],
    }),
    actions: {
        async loadTypeAchat() {
            if(this.typeAchat.length > 0) {
                return;
            }

            const notificationStore = NotificationStores();

            xhr.addRequestToQueue("GET", "/typeachat", undefined, true, true, false,
                (response) => {
                    if (response.code !== 200) {
                        if (response.code === 0 || !jsonValidator.validate(response.response)) {
                            notificationStore.addNotification(
                                t("errorDuringLoadPurchaseType"),
                                "error");
                        } else {
                            notificationStore.addNotification(
                                JSON.parse(response.response).message,
                                "error");
                        }
                    } else {
                        this.typeAchat = JSON.parse(response.response);
                    }
                });
        }
    },
    getters : {}
});
